import Pop from 'components/Popover/Pop';
import Text from 'components/Text/Text';
import { IItemDeviceBankSetting } from 'types';
import React from 'react';
import style from './TerminalList.module.scss';

interface ITerminalList {
	terminals: IItemDeviceBankSetting[];
}

const TerminalList: React.FC<ITerminalList> = ({ terminals }) => {
	const TerminalsContent = () => {
		return (
			<div className={style.container} data-test="TerminalsContent">
				{terminals.map((el) => (
					<div className={style.item} key={el.terminalId}>
						<Text
							translationKey={`${el.restaurantBankSetting.acquirerName} / ${el.terminalId}`}
							size="xs"
						/>
					</div>
				))}
			</div>
		);
	};

	return (
		<div data-test="TerminalList">
			{terminals.length > 1 ? (
				<Pop placement="bottomLeft" content={<TerminalsContent />} trigger="click">
					<div className={style.wrapper}>
						<Text
							translationKey={`${terminals[0].restaurantBankSetting.acquirerName} / ${terminals[0].terminalId}`}
							withTooltip={true}
						/>
						<span className={style.showListBtn}>&middot;&middot;&middot;</span>
					</div>
				</Pop>
			) : (
				<Text
					translationKey={
						terminals.length
							? `${terminals[0].restaurantBankSetting.acquirerName} / ${terminals[0].terminalId}`
							: '-'
					}
					withTooltip={true}
				/>
			)}
		</div>
	);
};

export default React.memo(TerminalList);
